<template>
  <CurrentVisaForm @on-submit="submitForm" />
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { notify } from 'notiwind'
import axiosInstance from '@/services'
import CurrentVisaForm from '@/views/services/public-visa/CurrentVisaForm/index.vue'

const i18n = useI18n()

async function submitForm(form) {
  const response = await axiosInstance.post('/api/guest/visa/getAllowedCancelVisaService', form)

  if (!response?.isValid) {
    notify(
      {
        group: 'warning',
        title: i18n.t(response.errorMessage)
      },
      -1
    )
    return
  }
  
  // TODO: what happens when it returns w data
}
</script>

<style lang="scss" scoped></style>
